import { AuthState } from '@okta/okta-auth-js';

import { LocationsSummaries } from '../../services/backend/LocationsSummaries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useLocationsSummaries: () => LocationsSummaries<AuthState> = () => {
  return useBaseApiClient(LocationsSummaries);
};
